import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faBuilding,
  faFax,
  faEnvelope,
  faMoneyBill,
  faGavel,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import "./DuiSchool.css";
import heroImage from "../../assets/images/pages/dui-school.jpg";
import ShellCard from "../../components/ShellCard";

const DuiSchool = () => {
  return (
    <>
      <div className="">
        <div className="container my-5">
          <div className="row">
            <div className="col-12 text-start">
              <ShellCard>
                <h1 className="mb-4 text-metro-yellow">DUI School</h1>

                <div className="row align-items-start mb-4">
                  <div className="col-md-7 ps-0">
                    <h3 className="mb-3 fw-bold text-metro-yellow">
                      DUI School Benefits
                    </h3>
                    <p className="text-white">
                      Instantly receive the DUI School enrollment form upon
                      completion of our online DUI School enrollment process.
                    </p>
                    <p className="text-white">Other benefits of enrolling with Metro DUI School:</p>
                    <ul className="list-group list-group-flush mb-3">
                      <li className="list-group-item d-flex align-items-start border-0 p-0 mb-2 bg-transparent text-white">
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="me-3 mt-1"
                          style={{ fontSize: "1.25rem" }}
                        />
                        14 locations – Most of any DUI school. Complete the DUI
                        course in any combination of our offices
                      </li>
                      <li className="list-group-item d-flex align-items-start border-0 p-0 mb-2 bg-transparent text-white">
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="me-3 mt-1"
                          style={{ fontSize: "1.25rem" }}
                        />
                        Enroll online – Instant DUI school enrollment forms for
                        hardship license
                      </li>
                      <li className="list-group-item d-flex align-items-start border-0 p-0 mb-2 bg-transparent text-white">
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="me-3 mt-1"
                          style={{ fontSize: "1.25rem" }}
                        />
                        24 hour access to your account to schedule and/or reschedule
                        your classes and evaluation online
                      </li>
                    </ul>
                    <a
                      href="https://dui.webwizardsusa.com/register"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn metro-btn-primary btn-lg fw-bold mt-2"
                    >
                      Register Now!
                    </a>
                  </div>
                  <div className="col-md-5 mt-4 mt-md-0 px-0 px-sm-3">
                    <img
                      src={heroImage}
                      className="img-fluid rounded"
                      alt="Don't Drink and Drive"
                    />
                  </div>
                </div>

                <div className="row g-4 mb-5">
                  <div className="col-md-4 col-sm-6 px-0 px-sm-3 ps-md-0">
                    <div className="h-100 p-3 rounded text-center" style={{ backgroundColor: "#333", border: "1px solid var(--metro-yellow)" }}>
                      <div className="mb-3">
                        <FontAwesomeIcon
                          icon={faMoneyBill}
                          size="3x"
                          className="text-metro-yellow"
                        />
                      </div>
                      <h4 className="text-white">DUI Level I</h4>
                      <p className="mb-3 text-white">Program</p>
                      <a
                        href="/dui-level1"
                        className="btn btn-sm fw-bold text-dark metro-btn-primary text-decoration-none"
                      >
                        More info
                      </a>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6 px-0 px-sm-3">
                    <div className="h-100 p-3 rounded text-center" style={{ backgroundColor: "#333", border: "1px solid var(--metro-yellow)" }}>
                      <div className="mb-3">
                        <FontAwesomeIcon
                          icon={faGavel}
                          size="3x"
                          className="text-metro-yellow"
                        />
                      </div>
                      <h4 className="text-white">DUI Program</h4>
                      <p className="mb-3 text-white">General information</p>
                      <a
                        href="/dui-school-details"
                        className="btn btn-sm fw-bold text-dark metro-btn-primary text-decoration-none"
                      >
                        More info
                      </a>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6 px-0 px-sm-3">
                    <div className="h-100 p-3 rounded text-center" style={{ backgroundColor: "#333", border: "1px solid var(--metro-yellow)" }}>
                      <div className="mb-3">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          size="3x"
                          className="text-metro-yellow"
                        />
                      </div>
                      <h4 className="text-white">DUI Level II</h4>
                      <p className="mb-3 text-white">Program</p>
                      <a
                        href="/dui-level2"
                        className="btn btn-sm fw-bold text-dark metro-btn-primary text-decoration-none"
                      >
                        More info
                      </a>
                    </div>
                  </div>
                </div>

                <h3 className="h3 accent-title mb-4 text-metro-yellow">DUI Information</h3>

                <div className="row g-4 mb-5">
                  <div className="col-md-6 ps-0">
                    <h3 className="h5 mb-3 text-white">Who must attend</h3>
                    <p className="mb-2 text-white">
                      Those who have been arrested for one of the following are
                      required to attend a DUI Program:
                    </p>
                    <ul className="info-list mb-0 text-white ps-3">
                      <li>
                        Driving Under the Influence (DUI), regardless of whether or
                        not it has been reduced to Reckless Driving
                      </li>
                      <li>Drug-related charges</li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <p className="text-white">
                      The deciding factors on whether or not to register for a DUI
                      Level I or DUI Level II are listed below. If you meet any
                      single one of the following, you will be required to complete
                      a DUI Level II, rather than a DUI Level I:
                    </p>
                    <ul className="info-list mb-0 text-white ps-3">
                      <li>Previous DUI arrest</li>
                      <li>Previous DUI conviction</li>
                      <li>Previous DUI program attendance</li>
                    </ul>
                  </div>
                </div>

                <h3 className="h5 mb-3 text-metro-yellow">How it works</h3>
                <div className="stepper mb-5 text-white">
                  <div className="step d-flex mb-3 p-3 rounded" style={{ backgroundColor: "#333", border: "1px solid var(--metro-yellow)" }}>
                    <span className="step-badge me-3 fw-bold text-metro-yellow fs-5">1.</span>
                    <div>
                      <p className="step-title fw-bold mb-1">Register online</p>
                      <p className="mb-0">
                        Choose your <strong>class schedule</strong> during
                        registration.
                      </p>
                    </div>
                  </div>
                  <div className="step d-flex mb-3 p-3 rounded" style={{ backgroundColor: "#333", border: "1px solid var(--metro-yellow)" }}>
                    <span className="step-badge me-3 fw-bold text-metro-yellow fs-5">2.</span>
                    <div>
                      <p className="step-title fw-bold mb-1">Attend class</p>
                      <p className="mb-0">
                        Level I or II class hours as required by your case.
                      </p>
                    </div>
                  </div>
                  <div className="step d-flex mb-3 p-3 rounded" style={{ backgroundColor: "#333", border: "1px solid var(--metro-yellow)" }}>
                    <span className="step-badge me-3 fw-bold text-metro-yellow fs-5">3.</span>
                    <div>
                      <p className="step-title fw-bold mb-1">Schedule evaluation</p>
                      <p className="mb-0">Complete your one-hour evaluation.</p>
                    </div>
                  </div>
                  <p className="mt-4">
                    The DUI program consists of class hours and a one-hour evaluation
                    (the number of class hours depends on whether it is a Level I or
                    II). This online registration will allow you to choose your class
                    schedule.
                  </p>

                  <p>
                    For the steps necessary to schedule your evaluation, which may be
                    done after you register,{" "}
                    <Link
                      to="/dui-school-details"
                      className="text-metro-yellow fw-bold"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      please click here
                    </Link>
                    .
                  </p>
                </div>

                <h3 className="h5 mb-3 text-metro-yellow">Forms you'll receive after registering</h3>
                <p className="text-white">
                  Upon completing the registration process, you will be receiving an
                  e-mail with everything you need to know about the DUI program. These
                  forms include the:
                </p>
                <ul className="text-white mb-4 ps-3">
                  <li>Proof of Enrollment</li>
                  <li>DUI Class Schedule</li>
                  <li>Rules and Regulations</li>
                  <li>Request to Release or Obtain Information (2)</li>
                  <li>Important Notice (2)</li>
                  <li>Receipt</li>
                </ul>

                <p className="mb-3 text-white">
                  We will need a signed copy of these forms. After printing and
                  signing the forms, you may:
                </p>
                <ul className="list-group list-group-flush submission-list mb-3">
                  <li className="list-group-item d-flex align-items-center border-0 bg-transparent text-white px-0">
                    <FontAwesomeIcon
                      icon={faBuilding}
                      className="me-3"
                      style={{
                        fontSize: "1.25rem",
                        color: "var(--metro-yellow)",
                      }}
                    />
                    <span>
                      Physically bring them in to any one of our{" "}
                      <Link
                        to="/contact-us"
                        className="text-metro-yellow fw-bold"
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        offices
                      </Link>
                    </span>
                  </li>
                  <li className="list-group-item d-flex align-items-center border-0 bg-transparent text-white px-0">
                    <FontAwesomeIcon
                      icon={faFax}
                      className="me-3"
                      style={{
                        fontSize: "1.25rem",
                        color: "var(--metro-yellow)",
                      }}
                    />
                    <span>
                      <Link
                        to="/contact-us"
                        className="text-metro-yellow fw-bold"
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        Fax
                      </Link>{" "}
                      the forms
                    </span>
                  </li>
                  <li className="list-group-item d-flex align-items-center border-0 bg-transparent text-white px-0">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      className="me-3"
                      style={{
                        fontSize: "1.25rem",
                        color: "var(--metro-yellow)",
                      }}
                    />
                    <span>
                      <a
                        href="mailto:info@metrotrafficschool.com"
                        className="text-metro-yellow fw-bold"
                      >
                        Email the forms
                      </a>
                    </span>
                  </li>
                </ul>

                <a
                  href="https://dui.webwizardsusa.com/register"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn metro-btn-primary btn-lg fw-bold mt-2"
                >
                  Register Now!
                </a>

                <div className="mt-4">
                  <h4 className="h5 text-metro-yellow">Important Notice</h4>
                  <p className="text-white">
                    Those arrested for DUI may apply for an immediate hardship
                    driver’s license, which may allow your driving privileges to be
                    reinstated on a restricted basis for driving to and from work,
                    required on-the-job driving, and driving for educational, church
                    and medical purposes. To be eligible you must enroll in DUI School
                    and apply for the hardship license within <strong>10 days</strong>{" "}
                    from the DUI arrest. Below are the steps to apply for an immediate
                    hardship license:
                  </p>
                  <ol className="hardship-steps text-white ps-3">
                    <li>
                      Enroll in DUI School and obtain a proof of enrollment form.
                    </li>
                    <li>
                      Complete DMV waiver form{" "}
                      <a
                        href="https://metrotrafficschool.com/SR50BizHub13082003060.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-metro-yellow fw-bold"
                      >
                        HSMV 72034
                      </a>
                      .
                    </li>
                    <li>
                      Take proof of enrollment and waiver form (HSMV 72034) to the{" "}
                      <Link
                        to="/bureau-administrative-review-office"
                        className="text-metro-yellow fw-bold"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Bureau of Administrative Review office
                      </Link>
                      .
                    </li>
                  </ol>
                  <p className="text-white">
                    Upon registering for this program, the{" "}
                    <strong>Proof of Enrollment</strong> will be automatically sent to
                    you by email or you can log into your account and print it out.
                  </p>
                </div>
              </ShellCard>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DuiSchool;
